<template>
<nav id="site-navigation" class="has-branding main-navigation nav-align-right sub-menu-right" aria-label="Primary" itemtype="https://schema.org/SiteNavigationElement" itemscope>
  <div class="inside-navigation">
    <div class="navigation-branding">
      <div class="site-logo">
        <a href="https://snapsinsta.com/" title="GBWhatsApp" rel="home">
          <img class="header-image is-logo-image" alt="GBWhatsApp" src="../assets/logo.webp" title="GBWhatsApp">
        </a>
      </div>
      <p class="main-title" itemprop="headline">
        <a href="https://snapsinsta.com/" rel="home">
          snapsinsta
        </a>
      </p>
    </div>
    <ul id="menu-primary-menu" class="menu sf-menu mobile-menu-page" v-show="isMenuClicked">
      <!-- <li id="menu-item-32" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-13 current_page_item menu-item-32">
        <router-link :to="{ name: `${selectedLanguage}-gb` }" exact>{{ this.translation[selectedLanguage].home }}</router-link>
      </li> -->
      <!-- <li id="menu-item-33" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <a href="https://snapsinsta.com/download/" class="download-btn">Download</a>
      </li>
       -->
      <li
        id="menu-item-tools"
        class="menu-item menu-item-type-custom menu-item-has-children tools-menu-item"
        :class="{ 'menu-open': isToolsMenuOpen }"
      >
        <a
          href="javascript:void(0)"
          class="nav-dropdown-toggle nav-dropdown-toggle--link"
          aria-haspopup="menu"
          :aria-expanded="isToolsMenuOpen ? 'true' : 'false'"
          @click.stop="toggleToolsMenu"
        >
          <span class="nav-dropdown-toggle__label">{{ toolsMenuLabel }}</span>
          <span class="dropdown-arrow" aria-hidden="true"></span>
        </a>
        <ul v-show="isToolsMenuOpen" class="sub-menu nav-dropdown-panel tools-dropdown" role="menu">
          <li
            v-for="tool in instagramTools"
            :key="tool.path"
            class="menu-item"
            :class="{ active: isToolActive(tool.path) }"
            role="none"
          >
            <router-link
              :to="tool.path"
              role="menuitem"
              @click.native="closeMenus"
            >{{ tool.label }}</router-link>
          </li>
        </ul>
      </li>
      <li id="menu-item-34" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
        <a href="https://snapsinsta.com/blog/">{{ navText.blogs }}</a>
      </li>
      <li id="menu-item-35" class="menu-item menu-item-type-custom menu-item-has-children language-menu-item" :class="{ 'menu-open': isLanguageMenuOpen }">
        <a
          href="javascript:void(0)"
          class="nav-dropdown-toggle"
          aria-haspopup="listbox"
          :aria-expanded="isLanguageMenuOpen ? 'true' : 'false'"
          @click.stop="toggleLanguageMenu"
        >
          <span class="nav-dropdown-toggle__label">{{ currentLanguageLabel }}</span>
          <span class="dropdown-arrow" aria-hidden="true"></span>
        </a>
        <ul class="sub-menu nav-dropdown-panel language-dropdown" role="listbox" v-show="isLanguageMenuOpen">
          <li
            v-for="language in availableLanguages"
            :key="language.code"
            class="menu-item"
            :class="{ active: language.code === selectedLanguage }"
          >
            <a
              href="javascript:void(0)"
              role="option"
              :aria-current="language.code === selectedLanguage ? 'true' : null"
              @click.stop="switchLanguage(language.code)"
            >
              {{ language.label }}
            </a>
          </li>
        </ul>
      </li>
    </ul>

    <div id="primary-menu" class="main-nav">
      <!-- mobile -->
      <div class="mobile-menu" v-if="$global.isMobileDevice()">
        <div class="menu-toggle" @click="isMenuClicked=!isMenuClicked">
          <img src="@/assets/menu.svg" alt="menu button" v-if="!isMenuClicked">
          <img src="@/assets/xmark-black.svg" alt="close button" v-else>
        </div>
      </div>
      <!-- pc -->
      <ul v-else id="menu-primary-menu" class="menu sf-menu">
        <!-- <li id="menu-item-33" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33 header-download">
          <a href="https://snapsinsta.com/download/" class="download-btn">Download</a>
        </li>
       -->
        <li
          id="menu-item-tools-pc"
          class="menu-item menu-item-type-custom menu-item-has-children tools-menu-item"
          :class="{ 'menu-open': isToolsMenuOpen }"
        >
          <a
            href="javascript:void(0)"
            class="nav-dropdown-toggle nav-dropdown-toggle--link"
            aria-haspopup="menu"
            :aria-expanded="isToolsMenuOpen ? 'true' : 'false'"
            @click.stop="toggleToolsMenu"
          >
            <span class="nav-dropdown-toggle__label">{{ toolsMenuLabel }}</span>
            <span class="dropdown-arrow" aria-hidden="true"></span>
          </a>
          <ul v-show="isToolsMenuOpen" class="sub-menu nav-dropdown-panel tools-dropdown" role="menu">
            <li
              v-for="tool in instagramTools"
              :key="tool.path"
              class="menu-item"
              :class="{ active: isToolActive(tool.path) }"
              role="none"
            >
              <router-link
                :to="tool.path"
                role="menuitem"
                @click.native="closeMenus"
              >{{ tool.label }}</router-link>
            </li>
          </ul>
        </li>
        <li id="menu-item-34" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <a href="/blog/">{{ navText.blogs }}</a>
        </li>
        <li id="menu-item-35" class="menu-item menu-item-type-custom menu-item-has-children language-menu-item" :class="{ 'menu-open': isLanguageMenuOpen }">
          <a
            href="javascript:void(0)"
            class="nav-dropdown-toggle"
            aria-haspopup="listbox"
            :aria-expanded="isLanguageMenuOpen ? 'true' : 'false'"
            @click.stop="toggleLanguageMenu"
          >
            <span class="nav-dropdown-toggle__label">{{ currentLanguageLabel }}</span>
            <span class="dropdown-arrow" aria-hidden="true"></span>
          </a>
          <ul class="sub-menu nav-dropdown-panel language-dropdown" role="listbox" v-show="isLanguageMenuOpen">
            <li
              v-for="language in availableLanguages"
              :key="language.code"
              class="menu-item"
              :class="{ active: language.code === selectedLanguage }"
            >
              <a
                href="javascript:void(0)"
                role="option"
                :aria-current="language.code === selectedLanguage ? 'true' : null"
                @click.stop="switchLanguage(language.code)"
              >
                {{ language.label }}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>
</template>

<script>
import Search from './Search.vue';
import { INSTAGRAM_TOOL_LINKS } from '@/data/instagram-related-tools';

export default {
  props: {
    selectedLanguage: {
      type: String,
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
    gotodownload: {
      type: Function,
    },
    apk: {
      type: [String, Object],
    },
  },
  components: {
    Search,
  },
  data() {
    return {
      isHovered: false,
      isMenuClicked: false,
      isModClicked: false,
      isSearchClicked: false,
      isLanguageMenuOpen: false,
      isToolsMenuOpen: false,
      instagramTools: INSTAGRAM_TOOL_LINKS,
      availableLanguages: [
        { code: 'en', label: 'English' },
        { code: 'tr', label: 'Türkçe' },
        { code: 'ar', label: 'العربية' },
        { code: 'hi', label: 'हिन्दी' },
        { code: 'es', label: 'Español' },
        { code: 'fr', label: 'Français' },
        { code: 'br', label: 'Português' },
      ],
      lang: [{
          lang: 'en',
          val: '🇺🇸 English'
        },
        {
          lang: 'ar',
          val: '🇦🇪 اَلْعَرَبِيَّةُ'
        },
        {
          lang: 'id',
          val: '🇮🇩 Bahasa Indonesia'
        },
        {
          lang: 'pt',
          val: '🇵🇹 Português'
        },
        {
          lang: 'es',
          val: '🇪🇸 Español'
        },
        {
          lang: 'hi',
          val: '🇮🇳 हिंदी'
        },
      ],
      translation: {
        en: {
          home: 'Home',
          download: 'Download',
          tools: 'Tools',
          blogs: 'Blogs',
          language: 'Language',
          mod: 'WhatsApp Mods',
        },
        tr: {
          home: 'Ana Sayfa',
          download: 'İndir',
          blogs: 'Bloglar',
          language: 'Dil',
          mod: 'WhatsApp Modları',
        },
        ar: {
          home: 'الصفحة الرئيسية',
          download: 'تحميل',
          blogs: 'المدونات',
          language: 'اللغة',
          mod: 'مودات واتس اب',
        },
        id: {
          home: 'Beranda',
          download: 'Unduh',
          blogs: 'Blog',
          language: 'Bahasa',
          mod: 'Mod WhatsApp',
        },
        pt: {
          home: 'Casa',
          download: 'Baixar',
          blogs: 'Blogs',
          language: 'Idioma',
          mod: 'Mods do WhatsApp',
        },
        br: {
          home: 'Início',
          download: 'Baixar',
          blogs: 'Blogs',
          language: 'Idioma',
          mod: 'Mods do WhatsApp',
        },
        es: {
          home: 'Casa',
          download: 'Descargar',
          blogs: 'Blogs',
          language: 'Idioma',
          mod: 'Mods de WhatsApp',
        },
        hi: {
          home: 'घर',
          download: 'डाउनलोड',
          blogs: 'ब्लॉग',
          language: 'भाषा',
          mod: 'व्हाट्सएप मोड्स',
        },
        fr: {
          home: 'Accueil',
          download: 'Télécharger',
          blogs: 'Blogs',
          language: 'Langue',
          mod: 'Mods WhatsApp',
        },
      },
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  watch: {
    isSearchClicked(newVal) {
      if (!newVal) {
        this.$refs.searchComponent?.resetSearch();
      }
    }
  },
  computed: {
    navText() {
      return this.translation[this.selectedLanguage] || this.translation.en;
    },
    currentLanguageLabel() {
      const current = this.availableLanguages.find(
        (language) => language.code === this.selectedLanguage
      );
      return current ? current.label : 'English';
    },
    toolsMenuLabel() {
      return (this.navText && this.navText.tools) || 'Tools';
    },
  },
  methods: {
    changeLanguage(lang) {
      console.log("changelang: ", lang);
      console.log("page: ", this.page);
      this.$router.push({
        name: `${this.selectedLanguage}-${this.page}`
      });
    },
    download() {
      if (typeof this.gotodownload === "function") {
        this.gotodownload();
      } else {
        console.error("gotodownload is not a function");
      }
    },
    toggleLanguageMenu() {
      this.isLanguageMenuOpen = !this.isLanguageMenuOpen;
      this.isToolsMenuOpen = false;
    },
    toggleToolsMenu() {
      this.isToolsMenuOpen = !this.isToolsMenuOpen;
      this.isLanguageMenuOpen = false;
    },
    closeMenus() {
      this.isToolsMenuOpen = false;
      this.isLanguageMenuOpen = false;
      this.isMenuClicked = false;
    },
    isToolActive(path) {
      if (!this.$route || !path) {
        return false;
      }
      const current = this.$route.path || '';
      const normalized = path.endsWith('/') ? path : `${path}/`;
      return current === path || current === normalized || `${current}/` === normalized;
    },
    switchLanguage(lang) {
      this.isLanguageMenuOpen = false;
      const paths = {
        en: '/',
        tr: '/tr/',
        ar: '/ar/',
        hi: '/hi/',
        id: '/hi/',
        es: '/es/',
        fr: '/fr/',
        br: '/br/',
      };
      this.$router.push(paths[lang] || '/');
    },
    handleClickOutside(event) {
      const languageMenus = this.$el.querySelectorAll('.language-menu-item');
      const insideLanguage = Array.from(languageMenus).some((el) => el.contains(event.target));
      if (!insideLanguage) {
        this.isLanguageMenuOpen = false;
      }
      const toolsMenus = this.$el.querySelectorAll('.tools-menu-item');
      const insideTools = Array.from(toolsMenus).some((el) => el.contains(event.target));
      if (!insideTools) {
        this.isToolsMenuOpen = false;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#site-navigation {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

  .inside-navigation {
    width: 80%;
    margin: 0 auto;
    z-index: 9999;
    position: relative;
  }
}

#backtop {
  width: 30px;
  height: 30px;
  position: fixed;
  right: 50px;
  bottom: 100px;
  background: #f0f0f0;
  padding: 10px;
  border-radius: 50%;
  box-sizing: content-box;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.main-nav {
  .menu {
    list-style-type: none !important;
    margin: 0 !important;
    display: flex;
    align-items: center;
    li {
      position: relative;
      a {
        font-weight: 500 !important;
      }
    }
  }
}

.language-menu-item,
.tools-menu-item {
  position: relative;
}

.language-menu-item {
  margin-right: 10px;

  .nav-dropdown-toggle {
    box-sizing: border-box;
    min-width: 164px;
    height: 42px;
    padding: 0 14px !important;
    border: 1px solid #d7e3eb;
    border-radius: 9px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(19, 65, 89, 0.06);
    color: #203f52 !important;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    font-size: 15px !important;
    font-weight: 600 !important;
    line-height: 40px !important;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, color 0.2s ease;

    &:hover,
    &:focus {
      border-color: #79b9dc;
      box-shadow: 0 0 0 3px rgba(0, 137, 174, 0.1);
      color: #007ba5 !important;
      outline: none;
    }

    .nav-dropdown-toggle__label {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .dropdown-arrow {
      flex: 0 0 auto;
      width: 7px;
      height: 7px;
      margin-top: -3px;
      border-right: 2px solid currentColor;
      border-bottom: 2px solid currentColor;
      transform: rotate(45deg);
      transition: transform 0.2s ease, margin-top 0.2s ease;
    }
  }

  &.menu-open > .nav-dropdown-toggle {
    border-color: #4aa9d6;
    box-shadow: 0 0 0 3px rgba(0, 137, 174, 0.12);
  }

  &.menu-open .dropdown-arrow {
    margin-top: 3px;
    transform: rotate(225deg);
  }

  > .nav-dropdown-panel {
    right: 0;
    left: auto;
  }
}

.tools-menu-item {
  .nav-dropdown-toggle--link {
    box-sizing: border-box;
    min-width: 0;
    height: auto;
    padding: 8px 4px !important;
    border: none;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    color: #121212 !important;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 15px !important;
    font-weight: 500 !important;
    line-height: 1.4 !important;
    transition: color 0.2s ease;

    &:hover,
    &:focus {
      color: #007ba5 !important;
      outline: none;
    }

    .dropdown-arrow {
      flex: 0 0 auto;
      width: 6px;
      height: 6px;
      margin-top: -2px;
      border-right: 2px solid currentColor;
      border-bottom: 2px solid currentColor;
      transform: rotate(45deg);
      transition: transform 0.2s ease, margin-top 0.2s ease;
    }
  }

  &.menu-open > .nav-dropdown-toggle--link {
    color: #007ba5 !important;
  }

  &.menu-open .dropdown-arrow {
    margin-top: 2px;
    transform: rotate(225deg);
  }

  > .tools-dropdown {
    left: 0;
    right: auto;
    width: 320px;
    min-width: 320px;
  }
}

.language-menu-item,
.tools-menu-item {
  > .nav-dropdown-panel {
    position: absolute;
    top: calc(100% + 6px);
    box-sizing: border-box;
    max-width: calc(100vw - 32px);
    max-height: 340px;
    overflow-y: auto;
    margin: 0 !important;
    padding: 8px;
    background: #fff;
    border: 1px solid #e1e9ef;
    border-radius: 10px;
    box-shadow: 0 14px 34px rgba(28, 56, 75, 0.16), 0 3px 8px rgba(28, 56, 75, 0.08);
    z-index: 1000;
    list-style: none !important;

    > .menu-item {
      width: 100%;
      margin: 0;
      padding: 0;

      + .menu-item {
        margin-top: 2px;
      }

      > a {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        min-height: 46px;
        padding: 0 14px !important;
        border-radius: 7px;
        color: #2a4352 !important;
        font-size: 15px !important;
        font-weight: 500 !important;
        line-height: 1.35 !important;
        text-decoration: none;
        text-align: left;
        transition: background-color 0.18s ease, color 0.18s ease;

        &:hover,
        &:focus {
          background-color: #f3f7fa;
          color: #007ba5 !important;
          outline: none;
        }
      }

      &.active > a {
        background-color: #e6f4fb;
        color: #0077ad !important;
        font-weight: 600 !important;
      }
    }
  }
}

.language-menu-item > .nav-dropdown-panel {
  width: 260px;
  min-width: 260px;
}

@media screen and (max-width: 768px) {

  .inside-navigation {

    .mobile-menu-page {
      position: absolute;
      top: 100%;
      width: 100%;
      z-index: 1001;
      margin: 0 !important;

      .menu-item {
        padding: 14px 0;
        margin-bottom: 0 !important;
        background: #fff;

        a, div {
          font-size: 15px;
          text-align: center;
          color: #121212;
          display: block;
        }
      }
      
      .language-menu-item {
        > .nav-dropdown-toggle {
          display: flex !important;
          width: calc(100% - 32px);
          min-width: 0;
          margin: 0 auto;
          text-align: left;
        }

        > .nav-dropdown-panel {
          position: static;
          box-sizing: border-box;
          width: calc(100% - 32px);
          min-width: 0;
          max-width: none;
          max-height: 300px;
          margin: 8px auto 0 !important;
          box-shadow: none;
          border: 1px solid #e8eef2;
          background: #fff;

          .menu-item {
            a {
              padding: 12px 20px;
              text-align: left;
            }
          }
        }
      }

      .tools-menu-item {
        > .nav-dropdown-toggle--link {
          display: inline-flex !important;
          justify-content: center;
          width: auto;
          margin: 0 auto;
        }

        > .nav-dropdown-panel {
          position: static;
          box-sizing: border-box;
          width: calc(100% - 32px);
          min-width: 0;
          max-width: none;
          max-height: 300px;
          margin: 8px auto 0 !important;
          box-shadow: none;
          border: 1px solid #e8eef2;
          background: #fff;

          .menu-item a {
            padding: 12px 20px;
            text-align: left;
          }
        }
      }

      .tools-menu-item > .tools-dropdown {
        width: calc(100% - 32px);
        min-width: 0;
      }
    }
  }

  .main-nav {
    flex: 1;
    margin-right: 10px;

    .mobile-menu {
      display: flex;
      justify-content: flex-end;
      position: relative;

      .language-selector {
        width: 60%;

        #language-select {
          width: 100%;
        }
      }

      .menu-toggle {
        display: block;
        display: flex;
        justify-content: center;
        padding: 12px 12px;
        margin-bottom: 0;

        img {
          width: 23px;
          height: 23px;
        }
      }

      .search-toggle {
        display: block;
        padding: 12px 12px;
        display: flex;
        justify-content: center;
        margin-bottom: 0;

        img {
          width: 23px;
          height: 23px;
        }
      }
    }
  }
}
</style>
